// Invilus Hero carousel — auto-rotates slides with full A11y compliance.
// Loaded with defer attribute so it does not block initial render.
//
// A11y features (WCAG 2.2.2):
// - Respects prefers-reduced-motion (no autoplay when user opts out)
// - Pauses on hover and keyboard focus inside the hero
// - Visible play/pause toggle button (Unicode symbols, screen-reader labelled)
// - Inactive slides receive the `inert` attribute so their links/buttons
//   are not reachable via tab order or pointer events.
(function () {
  const heroes = document.querySelectorAll('.invilus-hero[data-autoplay="true"]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  heroes.forEach(function (hero) {
    const slides = hero.querySelectorAll('.invilus-hero__slide');
    const dots = hero.querySelectorAll('.invilus-hero__dot');
    const speed = parseInt(hero.dataset.speedMs, 10) || 7000;
    if (slides.length < 2) return;

    let currentIndex = 0;
    let timer = null;
    let isPlaying = false;
    let isHovered = false;
    let hasFocus = false;

    function showSlide(index) {
      slides.forEach(function (slide, i) {
        const isActive = i === index;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        // Inert: prevents focus and click on hidden slides; modern browsers only.
        if (isActive) {
          slide.removeAttribute('inert');
        } else {
          slide.setAttribute('inert', '');
        }
      });
      dots.forEach(function (dot, i) {
        const isActive = i === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
      currentIndex = index;
    }

    function startTimer() {
      stopTimer();
      timer = setInterval(function () {
        showSlide((currentIndex + 1) % slides.length);
      }, speed);
    }

    function stopTimer() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function play() {
      isPlaying = true;
      updateToggleButton();
      // Honour current pause-on-hover/focus state.
      if (!isHovered && !hasFocus) {
        startTimer();
      }
    }

    function pause() {
      isPlaying = false;
      stopTimer();
      updateToggleButton();
    }

    // Initialise inert on hidden slides.
    showSlide(0);

    // Build pause/play toggle button.
    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'invilus-hero__playpause';
    toggle.setAttribute('aria-pressed', 'false');
    hero.appendChild(toggle);

    function updateToggleButton() {
      if (isPlaying) {
        toggle.setAttribute('aria-pressed', 'false');
        toggle.setAttribute('aria-label', 'Slideshow pausieren');
        toggle.innerHTML = '<span aria-hidden="true">&#10073;&#10073;</span>';
      } else {
        toggle.setAttribute('aria-pressed', 'true');
        toggle.setAttribute('aria-label', 'Slideshow abspielen');
        toggle.innerHTML = '<span aria-hidden="true">&#9654;</span>';
      }
    }

    toggle.addEventListener('click', function () {
      if (isPlaying) {
        pause();
      } else {
        play();
      }
    });

    // Pause on hover; resume on leave (only if autoplay is enabled).
    hero.addEventListener('mouseenter', function () {
      isHovered = true;
      if (isPlaying) stopTimer();
    });
    hero.addEventListener('mouseleave', function () {
      isHovered = false;
      if (isPlaying && !hasFocus) startTimer();
    });

    // Pause on keyboard focus inside the hero; resume on focus out.
    hero.addEventListener('focusin', function () {
      hasFocus = true;
      if (isPlaying) stopTimer();
    });
    hero.addEventListener('focusout', function (event) {
      if (!hero.contains(event.relatedTarget)) {
        hasFocus = false;
        if (isPlaying && !isHovered) startTimer();
      }
    });

    // Dot navigation.
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        showSlide(i);
        if (isPlaying && !isHovered && !hasFocus) startTimer();
      });
    });

    // React to runtime changes of prefers-reduced-motion.
    function syncMotionPreference() {
      if (reduceMotion.matches) {
        pause();
      } else {
        play();
      }
    }

    if (reduceMotion.addEventListener) {
      reduceMotion.addEventListener('change', syncMotionPreference);
    } else if (reduceMotion.addListener) {
      // Safari < 14
      reduceMotion.addListener(syncMotionPreference);
    }

    // Initial state honours user preference.
    syncMotionPreference();
  });
})();
